import { render, staticRenderFns } from "./LiveOrders.vue?vue&type=template&id=123787fc"
import script from "./LiveOrders.vue?vue&type=script&lang=js"
export * from "./LiveOrders.vue?vue&type=script&lang=js"
import style0 from "./LiveOrders.vue?vue&type=style&index=0&id=123787fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports